<template>
  <div class="j_service_svg_page">
    <j-page-layout-builder-svg
      ref="pageSvgBuilder"
      :mode="__C_.DASHBOARD.BUILDER_MODE_VIEWER"
      :chart-items="chartItems"
      :filters="filteredValues"
      :callback="Callbacks"
      @request-action="onRequestedAction"
      @request-procedure="onRequestProc"
      @resize="onDashboardResize"
      @selectedItems="selectedItems"
      @complete="onComplete"
    />

    <j-modal-slide-component 
      v-model="modalOpen" 
      :component="componentName" 
      :filters="filtersModal" 
      :target="target" 
      :prop-export-info="propExportInfo" 
    />

    <service-todo-list-modal
      v-model="todoModalOpened"
      :key-value="todoItemKey"
      @saved="onTodoListSaved"
      @deleted="onTodoListDeleted"
    />
  </div>
</template>

<script>
import __C from '@/primitives/_constant_'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Loading from '@/mixins/loading.mixin'
import JServiceComponents from '@/components/JServiceComponentTargets'

import SystemService from '@/services/system.service'

import { files as FileManagerApi } from '../../../lib/filebrowser/src/api'
import ServiceTodoListModal from './modal/ServiceToDoList.modal.vue'

export default {
  name: 'service-svg-page',
  mixins: [Loading],
  components: {
    ...JServiceComponents,
    ServiceTodoListModal,
  },
  data: () => ({
    systemService: null,
    rData: null,
    componentName: '',
    target: {},
    propExportInfo: {},
    filtersModal: {},

    dimention: {},
    localFilters: {},
    infoRequired: false,

    chartComplete: false,

    todoModalOpened: false,
    todoItemKey: null,
  }),
  computed: {
    ...mapState(__C.STORE_NAMESPACE.ACCOUNT, ['account']),
    ...mapState(__C.STORE_NAMESPACE.APP_SERVICE, ['commentOpened', 'modalOpened', 'popupEqOpened', 'popupHlEqOpened', 'popupFreeOpened', 'popupHlsOpened', 'popupFreeCallback', 'callbackData']),
    ...mapState(__C.STORE_NAMESPACE.DASHBOARD, ['pageSvg', 'resultSet']),
    ...mapGetters(__C.STORE_NAMESPACE.APPLICATION, ['navStateId']),
    ...mapGetters(__C.STORE_NAMESPACE.APP_SERVICE, ['filteredValues']),

    __C_() { return __C },

    chartItems() {
      return !this.resultSet.chartItem || Object.keys(this.resultSet.chartItem).length === 0 ? [] : [this.resultSet.chartItem]
    },
    modalOpen: {
      get() {
        return this.modalOpened
      },
      set(val) {
        return this.setModalOpened(val)
      },
    },
    chartData() {
      return this.resultSet.chartItem.QResultSummary
    },
    Callbacks() {
      const callback = {
        ...(this.callbackData || {}),
        ...(this.popupFreeCallback || {}),
      }
      if (typeof callback.onProcedureResponse !== 'function') {
        callback.onProcedureResponse = (ret) => {
          console.log('[service callback.onProcedureResponse]',   ret)
        }
      }
      return callback
    },
  },

  beforeCreate() {
    // this.loading = true
    this.chartComplete = false
  },
  created() {
    
    this.loading = true

    this.systemService = new SystemService()

    this.setChild(__C.STORE_NAMESPACE_KEY.DASHBOARD)
    this.setType(__C.DASHBOARD.TYPE_CODE_PAGESVG)
    this.setPagecallFunc(this.run)
  },
  mounted() {},

  methods: {
    ...mapMutations(__C.STORE_NAMESPACE.CONFIG, ['setLayout']),
    ...mapMutations(__C.STORE_NAMESPACE.APPLICATION, ['setPagecallFunc', 'setNavState']),
    ...mapMutations(__C.STORE_NAMESPACE.APP_SERVICE, [
      'setChild',
      'setCommentOpened',
      'setCommentProps',
      'setFilteredValues',
      'setModalOpened',
      'setItems',
      'setPopupFreeOpened',
      'setPopupHlsOpened',
      'setPopupEqOpened',
      'setPopupHlEqOpened',
      'setSelectItems',
      'setImgPopupOpened',
      'setSharedData',
      'setCommentTitle',
    ]),
    ...mapMutations(__C.STORE_NAMESPACE.DASHBOARD, ['setDimention', 'setExtHeight', 'setType', 'setDashboardId']),
    ...mapActions(__C.STORE_NAMESPACE.DASHBOARD, ['getPageSvg', 'initService']),

    selectedItems(items) {
      this.setItems(items)      
    },
    onComplete(v) {
      this.chartComplete = true
      // // for the pdf printing from the API
      // if (this.filteredValues && this.filteredValues.infoRequired) {
      //   this.infoRequired = true
      //   this.localFilters = { ...this.filteredValues }
      // }
      // if (this.infoRequired) {
      //   setTimeout(() => {
      //     let elbox = document.querySelector('.j_page_svg_information').getBoundingClientRect()
      //     this.setExtHeight(elbox.height)
      //   }, 1000)
      // }
    },
    onDashboardResize(d) {
      this.dimention = d
      this.setDimention(d)
    },
    onRequestedAction(request) {
      let action___ = request.sender.action && request.sender.action.type == 'direct' ? request.sender.action : request.parent.action

      if (!action___) {
        console.log(`[USER: undefined 'action'] Target is not defined.`)
        return
      }

      if (request.sender.action.target == 'routeto') {
        if (!request.sender.action.path) console.log(`[USER: PROP UNDEFINED] Target path is not defined.`)
        else this.$router.push(request.sender.action.path)
        return
      }

      if (request.sender.action.target == 'filter') {
        // for mc skyline export pdf
        this.setFilteredValues({ ...request.sender.filters })
        return
      }

      // only for retrieving data result with given filter-value
      if (action___.target == 'none') {
        if (Object.keys(request.sender).includes('loading')) this.loading = request.sender.loading
        else this.loading = true

        this.setFilteredValues({ ...this.filteredValues, ...request.sender.filters })
        // params type object
        this.getPageSvg({ reqType: 'filtered', action: action___.name ? action___ : null }).then(() => {
          setTimeout(() => {
            this.loading = false
          }, 150)
        })
        return
      }

      if (action___.target == __C.REQUEST_ACTION.TARGET_URL) {
        // if (Object.keys(request.sender.filters).length > 0) this.setFiltersPushed(request.sender.filters)
        this.$router.push(action___.path)
        return
      }

      if (action___.target == __C.REQUEST_ACTION.TARGET_SINGLE_FILE_DOWNLOAD) {
        FileManagerApi.download(null, '', action___.path)
        return
      }

      if (!action___.component) {
        console.log(`[USER: undefined 'component'] Target Name is not defined.`)
        return
      }
      if (action___.component == __C.REQUEST_ACTION.COMPONENT_COMMENT) {
        if (action___.commentProps && action___.commentProps.title) this.setCommentTitle(action___.commentProps.title)

        if (action___.commentProps) this.setCommentProps(JSON.parse(JSON.stringify(action___.commentProps)))
        else this.setCommentProps({ refCode: `${__C.REQUEST_ACTION.COMPONENT_SVGPAGE}_${this.navStateId}` })

        this.setCommentOpened(true)

        return
      }

      // Opens the ToDo List modal when the SVG shape's configured action targets the ToDo List component
      if (action___.component == __C.REQUEST_ACTION.COMPONENT_TODOLIST) {
        this.openTodoListModal(action___.id)
        return
      }

      if (action___.target == __C.REQUEST_ACTION.TARGET_IMG_POPUP) {
        this.setImgPopupOpened({
          open: true,
          imgPath: request.sender.imgPath,
          dimention: request.sender.dimention,
        })
        return
      }

      // For the Pop-Up process
      if (action___.target != __C.REQUEST_ACTION.TARGET_POPUP && !action___.component) {
        console.log(`[USER: undefined 'Component Name'] Target Name is not defined.`)
        return
      }

      if ([__C.REQUEST_ACTION.TARGET_POPUP, __C.REQUEST_ACTION.TARGET_ROOM_POPUP, __C.REQUEST_ACTION.TARGET_POPUP_HL_EQ].includes(action___.target)) {
        if (request.sender.shared) this.setSharedData(request.sender.shared)
        if (action___.purpose == 'equipment-search' && !this.popupEqOpened) return

        this.setPopupEqOpened({
          open: true,
          queryid: action___.id,
          filters: request.sender.filters,
          data: request.sender.data,
          action: request.sender.action,
        })
        return
      }

      if (__C.REQUEST_ACTION.TARGET_POPUP_FREE == action___.target) {
        if (request.sender.shared) {
          this.setSharedData(request.sender.shared)
          return
        }
        if (action___.purpose == 'equipment-search' && !this.popupFreeOpened) return

        this.setPopupFreeOpened({
          open: true,
          component: action___.component,
          queryid: action___.id,
          queryname: action___.no,
          filters: request.sender.filters,
          filterString: request.sender.filterString,
          data: request.sender.data,
        })
        return
      }

      if (__C.REQUEST_ACTION.TARGET_POPUP_HLS == action___.target) {
        this.setPopupHlsOpened({
          open: true,
          component: action___.component,
          filters: request.sender.filters,
          data: request.sender.data,
        })
        return
      }

      this.setModalOpened(true)
      this.componentName = action___.component
      this.target = {
        code: __C.PAGE_COMPONENT.TYPE_MODAL,
        type: '',
        id: action___.id,
        no: action___.no,
      }
      this.filtersModal = {
        filters: request.sender.filters,
        iFilters: request.sender.iFilters,
      }
      this.propExportInfo = request.export

      console.log(`[USER: #DEBUG] Export Info  [0]: ${this.componentName} ${JSON.stringify(this.propExportInfo)}`)
      console.log(`[USER: #DEBUG] Target  [0]: ${this.componentName} ${JSON.stringify(this.target)}`)
      console.log(`[USER: #DEBUG] Filters [1]: ${JSON.stringify(this.filtersModal.filters)}`)
      console.log(`[USER: #DEBUG] iFilters[2]: ${JSON.stringify(this.filtersModal.iFilters)}`)
    },

    onRequestProc(req) {
      const builder = this.$refs.pageSvgBuilder
      const responseToBuilder = (ret) => {
        if (!builder) return
        if (typeof builder.retProcResponse === 'function') {
          console.log('service onRequestProc responseToBuilder ()', ret)
          builder.retProcResponse(ret)
        }
      }
      
      const requestId = req && req.requestId ? req.requestId : `${Date.now()}__EXCEL_EXPORT_PROC`
      const reqType = (req && req.type) ? req.type : ''
      const reqName = req && req.name ? req.name : ''

      if (!reqType) {
        responseToBuilder({ requestId, ok: false, error: 'Procedure type is empty', request: req })
        return
      }
      if (!reqName) {
        responseToBuilder({ requestId, ok: false, error: 'Procedure name is empty', request: req })
        return
      }

      this.loading = true

      const updateitem = {
        requestId,
        type: reqType,
        name: reqName,
        files: Array.isArray(req && req.files) ? req.files : [],
      }
      console.log('service onRequestProc', updateitem)

      // Option 1: success-only callback style (errors are logged in API layer)
      this.systemService.execProcedure(updateitem, (res) => {
        try {
          if (typeof res === 'undefined' || res === null) {
            console.warn('service onRequestProc: empty response (see console for API error)')
            return
          }
          
          const ret = { ok: true, data: res }
          console.log('service onRequestProc: response received', ret)
          responseToBuilder(ret.data)
        } finally {
          this.loading = false
        }
      })
    },
    onCodeChanged(filters) {
      this.localFilters = filters
      this.setFilteredValues(this.localFilters)
    },
    openTodoListModal(id = null) {
      this.todoItemKey = id || null
      this.todoModalOpened = true
      console.log('ServicePageSvg.vue openTodoListModal', this.todoItemKey, this.todoModalOpened)
    },
    async onTodoListSaved() {
      this.loading = true

      try {
        // 현재 필터 조건을 유지한 채 SVG 차트 데이터만 재조회
        await this.getPageSvg({
          reqType: 'filtered',
          action: null,
        })
      } finally {
        this.loading = false
      }
    },
    async onTodoListDeleted() {
      this.todoItemKey = null

      this.loading = true

      try {
        await this.getPageSvg({
          reqType: 'filtered',
          action: null,
        })
      } finally {
        this.loading = false
      }
    },
    run() {
      return this.initService().then(() => {
        let urlqueries = this.$route.query

        this.infoRequired = urlqueries.useinfo == 'true' ? true : false
        if (this.infoRequired) this.setFilteredValues({ infoRequired: true })

        if (urlqueries.filters) {
          this.localFilters = JSON.parse(urlqueries.filters)
          this.setFilteredValues({ ...this.filteredValues, ...JSON.parse(urlqueries.filters) })
        }

        return this.getPageSvg('init')
      })
    },
  },
}
</script>
